import React, { useEffect } from "react";
import { View, StyleSheet } from "react-native";
import { useSelector, useDispatch } from "react-redux";
import colors from "@constants/color";
import { getAllWalletMetaData, getWalletSummary } from "@services/api";
import { actions as walletActions } from "@reducers/oldWalletReducer";
import t from "@constants/localization";
import HeaderWithBackAndTitle from "@components/HeaderWithBackAndTitle";
import AggHeaderCard from "@screens/Wallet/v2/components/AggHeaderCard";

const WithdrawGullakMoneyHeader = ({ navigation, route }) => {
  const PATH = "screens/WithDrawGullakMoney/index";
  const dispatch = useDispatch();

  const { walletSummary = {} } = useSelector((state) => state.wallet);
  const { walletSummary: newWalletSummary } = useSelector(
    (state) => state.walletReducer,
  );
  useEffect(() => {
    if (!walletSummary) {
      getAllWalletMetaData()
        .then(({ data }) => {
          const {
            default: { toDate, fromDate },
          } = data.filters;
          dispatch(walletActions.setWalletMetaData(data));
          return getWalletSummary({ to: toDate, from: fromDate });
        })
        .then(({ data }) => {
          dispatch(walletActions.setWalletSummary(data));
        })
        .catch((err) => {
          console.log("eror from wallet fetch", err);
        });
    }
  }, [dispatch, walletSummary]);

  return (
    <>
      <HeaderWithBackAndTitle
        route={route}
        navigation={navigation}
        headertitle={t(`${PATH}/headerTitle`)}
      />
      <View style={{ marginTop: 20 }}>
        <AggHeaderCard summary={newWalletSummary?.summary} />
      </View>
    </>
  );
};

const styles = StyleSheet.create({
  beLikeRow: {
    flexDirection: "row",
    alignItems: "center",
  },
  headerContainer: {
    padding: 10,
  },
  text: {
    color: colors.white,
  },
});

export default WithdrawGullakMoneyHeader;
